import { createFileRoute } from '@tanstack/react-router'
import { seo } from '~/utils/seo'

function getFallbackSeoText(locale: string) {
  switch (locale) {
    case 'zh-CN': return { title: '美食分类 | TabeTabi', description: '探索日本各类美食的历史、文化与就餐指南。' }
    case 'zh-TW': return { title: '美食分類 | TabeTabi', description: '探索日本各類美食的歷史、文化與用餐指南。' }
    case 'ja': return { title: 'グルメカテゴリー | TabeTabi', description: '日本の多彩なグルメの歴史、文化、食事ガイドを探索しましょう。' }
    case 'ko': return { title: '미식 카테고리 | TabeTabi', description: '일본 다양한 미식의 역사, 문화, 식사 가이드를 탐색해보세요.' }
    default: return { title: 'Food Categories | TabeTabi', description: 'Explore all Japanese food categories.' }
  }
}

export const Route = createFileRoute('/{-$locale}/_public/categories/')({
  head: ({ params }) => {
    const locale = (params as any).locale || 'en'
    const fallback = getFallbackSeoText(locale)
    
    const { meta, links } = seo({
      title: fallback.title,
      description: fallback.description,
      pathname: `/categories`,
      locale,
    })

    return {
      meta,
      links,
    }
  },
  headers: () => {
    return {
      'Cache-Control': 'public, max-age=3600, s-maxage=86400, stale-while-revalidate=86400',
    }
  },
  component: CategoriesIndexPage,
})

import { CategoriesIndexPage } from '~/features/categories/components/CategoriesIndexPage'
